import { render, staticRenderFns } from "./CreateShopee.vue?vue&type=template&id=498cc87d&scoped=true"
import script from "./CreateShopee.vue?vue&type=script&lang=js"
export * from "./CreateShopee.vue?vue&type=script&lang=js"
import style0 from "./CreateShopee.vue?vue&type=style&index=0&id=498cc87d&prod&scoped=true&lang=css"
import style1 from "./CreateShopee.vue?vue&type=style&index=1&id=498cc87d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498cc87d",
  null
  
)

export default component.exports